import { MatDialogConfig } from '@angular/material/dialog';

export interface DialogEditTicketAmountData {
  ticketId: string;
  serviceId: string;
  currentTotal?: number | null;
  tickets?: any[];
  tipoCambio?: number | null;
  moneda?: string | null;
  tipoMoneda?: string | null;
  objTarifa?: { monedaTarifa?: string | null; tipoCambio?: number | null } | null;
  servicioTipoCambio?: number | null;
  nombreServicio?: string | null;
}

export const EDIT_TICKET_AMOUNT_PANEL_CLASS = 'create-order-panel';

export function buildEditTicketAmountDialogConfig(
  data: DialogEditTicketAmountData,
  options?: { disableClose?: boolean }
): MatDialogConfig<DialogEditTicketAmountData> {
  return {
    width: '460px',
    maxWidth: '94vw',
    panelClass: EDIT_TICKET_AMOUNT_PANEL_CLASS,
    autoFocus: false,
    disableClose: options?.disableClose ?? false,
    data
  };
}
